import { render } from "./SpotPriceContracts.vue?vue&type=template&id=73ebd5da"
import script from "./SpotPriceContracts.vue?vue&type=script&lang=js"
export * from "./SpotPriceContracts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__